import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  openModal,
  setActiveItem,
  setSelectedMenuItem,
} from "../../features/tableOfContents/TableOfContentsSlice";
import { isSameItem } from "./tableOfContents";

export function useTableOfContents() {
  const dispatch = useDispatch();
  const { isOpen, tableOfContents, activeItem, umbrellaNode } = useSelector(
    (state) => state.tableOfContents,
  );

  const isActiveItem = (item) => {
    return isSameItem(item, activeItem);
  };

  return {
    isOpen,
    tableOfContents,
    activeItem,
    umbrellaNode,
    openModal: () => dispatch(openModal()),
    closeModal: () => dispatch(closeModal()),
    setSelectedMenuItem: (item) => dispatch(setSelectedMenuItem(item)),
    isActiveItem,
    setActiveItem: (item) => dispatch(setActiveItem(item)),
  };
}
